var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1668 5.99992C11.1668 3.14575 8.85433 0.833252 6.00016 0.833252C3.146 0.833252 0.833496 3.14575 0.833496 5.99992C0.833496 8.58325 2.7085 10.7291 5.18766 11.1041V7.49992H3.87516V5.99992H5.18766V4.87492C5.18766 3.58325 5.9585 2.85409 7.12516 2.85409C7.7085 2.85409 8.29183 2.95825 8.29183 2.95825V4.22909H7.646C7.00016 4.22909 6.79183 4.62492 6.79183 5.04159V5.99992H8.22933L8.00016 7.49992H6.79183V11.1041C9.271 10.7291 11.1668 8.58325 11.1668 5.99992Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbIcon);
export default __webpack_public_path__ + "static/media/fbIcon.a257a5629544ebf77c1a11dbe5951aad.svg";
export { ForwardRef as ReactComponent };